module.exports = __webpack_public_path__ + "static/media/ic_low_risk.ddb3e4a6.svg";